export default function (element, data) {
    const form = element.querySelector('form');
    const textarea = element.querySelector('[name="search_query"]');
    const inputError = element.querySelector('.input-error');

    
    form.addEventListener('submit', function(e) {
        // const lines = textarea.value.split(/\r?\n|,/);
        // const valid = lines.some(line => line.trim().length >= 3);

        const lines = textarea.value
            .split(/\r?\n|,/)
            .map(l => l.trim())
            .filter(Boolean);

        const valid = lines.length > 0 && lines.every(line => line.length >= 3);

        if (!valid) {
            e.preventDefault();
            inputError.classList.add('show');
        }
    });

    textarea.addEventListener('input', function() {
        inputError.classList.remove('show');
    });
}
